import request from "@/utils/request";

// 入馆记录列表
export const entryRecordList = () => {
  return request({
    url: "/we_chat/ticket/log/list",
    method: "get",
  });
};

// 二维码
export const qrcode = (id) => {
  return request({
    url: "/we_chat/ticket/log/qrCode?id=" + id,
    method: "get",
  });
};
// 入馆记录详情
export const detail = (id) => {
  return request({
    url: "/we_chat/ticket/log/detail?id=" + id,
    method: "get",
  });
};
